import { isSet } from '../utils/isSet';
import { differenceInDays } from "date-fns";
import { addDays } from "date-fns";
import { subDays } from "date-fns";
import { formatISO } from "date-fns";
import { endOfDay } from "date-fns";

class HirePeriod {
    constructor(root){
        this.root = root;

        this.hireStartDateInput = this.root.querySelector("#hire-journey-input--start");
        this.hireEndDateInput = this.root.querySelector("#hire-journey-input--end");

        this.init();
    }

    init(){
        if(!isSet(this.hireStartDateInput) || !isSet(this.hireEndDateInput)) return;
        
        this.startDate = this.hireStartDateInput.value;
        if(!isSet(this.startDate)){
            this.startDate = addDays(formatISO(endOfDay(new Date())), 1);
        }

        this.endDate = this.hireEndDateInput.value;
        this.minimumHirePeriod = Number(this.root.getAttribute('minimum-hire-period'));
        
        if(!isSet(this.minimumHirePeriod)){
            this.minimumHirePeriod = 0;
        }

        this.maximumHirePeriod = Number(this.root.getAttribute('maximum-hire-period'));

        this.onStartDateChangeBound = this.#onStartDateChange.bind(this);
        this.onEndDateChangeBound = this.#onEndDateChange.bind(this);

        const calculatedMinimumEndDate = addDays(this.startDate, this.minimumHirePeriod);

        this.hireEndDateInput.setAttribute(
            'min', 
            formatISO(calculatedMinimumEndDate, { representation: 'date' })
        );

        this.addElementListeners();
    }


    /**
     * Adds bound methods to the elements
     */
    addElementListeners() {
        if(!this.hireStartDateInput || !this.hireEndDateInput) return;

        if(this.onStartDateChangeBound) this.hireStartDateInput.addEventListener( 'change', this.onStartDateChangeBound);
        if(this.onEndDateChangeBound) this.hireEndDateInput.addEventListener( 'change', this.onEndDateChangeBound);
    }


    #onStartDateChange(e = null){
        this.startDate = e.target.value;
        const endDate = this.hireEndDateInput.value;
        const newMinimumEndDate = addDays(this.startDate, this.minimumHirePeriod);

        if(isSet(endDate)){
            const startDate = this.startDate;

            const difference = differenceInDays(
                new Date(endDate),
                new Date(startDate)
            );
            
            if(difference < this.minimumHirePeriod){
                this.hireEndDateInput.value = formatISO(newMinimumEndDate, { representation: 'date' });
            }
        } else{
            this.hireEndDateInput.value = formatISO(newMinimumEndDate, { representation: 'date' });
        }

        this.endDate = this.hireEndDateInput.value;
    }

    #onEndDateChange(e = null){
        this.endDate = e.target.value;
        const startDate = this.hireStartDateInput.value;
        const newMinimumStartDate = subDays(this.endDate, this.minimumHirePeriod);

        if(isSet(startDate)){
            const endDate = this.endDate;

            const difference = differenceInDays(
                new Date(endDate),
                new Date(startDate)
            );

            if(difference < this.minimumHirePeriod){
                this.hireStartDateInput.value = formatISO(newMinimumStartDate, { representation: 'date' });
            }

        } else{
            this.hireStartDateInput.value = formatISO(newMinimumStartDate, { representation: 'date' });
        }

        this.startDate = this.hireStartDateInput.value;
    }
}

exports.HirePeriod = HirePeriod